import React, { Component } from "react";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer";

class ColumnSectionDropdown extends Component {
    constructor(props) {
      super(props);
      this.state = {
        listOpen: this.props.isOpen
      };
    }
    renderColumnNames = () => {
      return (
        <div className="col-md-12">
          <CheckBoxContainer
            toggleSelection={this.props.toggleSelection}
            checkboxItemsList={this.props.checkboxItemsList}
          />
        </div>
      );
    };
  
    render() {
      const { listOpen } = this.state;
      return (
        <div>           
          {listOpen && (              
            <div className="divFloatingColumnDropdown">
                <div className="row">
                   {this.renderColumnNames()}
                </div>
            </div>
          )}
        </div>
      );
    }
  }
  
  export default ColumnSectionDropdown;